import { render } from "./AutoScaleVmProfile.vue?vue&type=template&id=f9eab1d6&scoped=true"
import script from "./AutoScaleVmProfile.vue?vue&type=script&lang=js"
export * from "./AutoScaleVmProfile.vue?vue&type=script&lang=js"

import "./AutoScaleVmProfile.vue?vue&type=style&index=0&id=f9eab1d6&scoped=true&lang=scss"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9eab1d6"]])

export default __exports__